module.exports = __webpack_public_path__ + "static/media/Roboto-Light.2382fa8a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Light.ttf
// module id = 530
// module chunks = 0